(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["collection-toolbar"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-sort-select]').forEach((select) => {
    select.addEventListener('change', () => {
      select.form.submit();
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["locale-switcher"] && !Shopify.designMode) return;
  try {
    class LocaleSwitcher extends HTMLElement {
    connectedCallback() {
      this.select = this.querySelector('[data-locale-switcher-select]');
      this.form = this.querySelector('form');
      if (!this.select || !this.form) return;
      this.setAttribute('data-enhanced', '');
      this.select.addEventListener('change', () => this.form.submit());
    }
  }

  customElements.define('locale-switcher', LocaleSwitcher);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["page-gallery-grid"] && !Shopify.designMode) return;
  try {
    class GalleryLightbox extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('[data-gallery-item]'));
      this.lightbox = this.querySelector('[data-gallery-lightbox]');
      this.lightboxImg = this.querySelector('[data-gallery-lightbox-img]');
      this.lightboxMeta = this.querySelector('[data-gallery-lightbox-meta]');
      this.activeIndex = 0;
      this.lastFocused = null;

      this.items.forEach((item, index) => {
        item.addEventListener('click', () => this.openLightbox(index));
      });

      this.querySelectorAll('[data-gallery-prev]').forEach((button) => {
        button.addEventListener('click', () => this.step(-1));
      });
      this.querySelectorAll('[data-gallery-next]').forEach((button) => {
        button.addEventListener('click', () => this.step(1));
      });

      if (this.lightbox) {
        const closeButton = this.lightbox.querySelector('[data-gallery-lightbox-close]');
        if (closeButton) closeButton.addEventListener('click', () => this.closeLightbox());
        this.lightbox.addEventListener('click', (event) => {
          if (event.target === this.lightbox) this.closeLightbox();
        });
        this.lightbox.addEventListener('close', () => {
          if (this.lastFocused) this.lastFocused.focus();
        });
      }

      this.addEventListener('keydown', (event) => {
        if (!this.lightbox || !this.lightbox.open) return;
        if (event.key === 'ArrowLeft') this.step(-1);
        if (event.key === 'ArrowRight') this.step(1);
      });
    }

    showIndex(index) {
      const item = this.items[index];
      if (!item) return;
      this.activeIndex = index;
      if (this.lightboxImg) {
        this.lightboxImg.src = item.dataset.zoom;
        this.lightboxImg.alt = item.dataset.alt || '';
      }
      if (this.lightboxMeta) {
        this.lightboxMeta.replaceChildren();
        const template = item.parentElement.querySelector('[data-gallery-meta-template]');
        if (template) this.lightboxMeta.appendChild(template.content.cloneNode(true));
      }
    }

    step(direction) {
      const nextIndex = this.activeIndex + direction;
      if (nextIndex < 0 || nextIndex >= this.items.length) return;
      this.showIndex(nextIndex);
    }

    openLightbox(index) {
      if (!this.lightbox) return;
      this.lastFocused = this.items[index];
      this.showIndex(index);
      this.lightbox.showModal();
    }

    closeLightbox() {
      if (!this.lightbox) return;
      this.lightbox.close();
    }
  }

  customElements.define('gallery-lightbox', GalleryLightbox);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-buybox"] && !Shopify.designMode) return;
  try {
    class ProductForm extends HTMLElement {
    connectedCallback() {
      this.priceEl = this.querySelector('[data-product-price]');
      this.stockEl = this.querySelector('[data-stock-label]');
      this.variantIdInput = this.querySelector('[data-variant-id-input]');
      this.atcButton = this.querySelector('[data-atc-button]');
      this.variantListItems = Array.from(this.querySelectorAll('[data-variant-list] li'));
      this.optionGroups = Array.from(this.querySelectorAll('.variant-selector__options'));
      if (this.variantListItems.length === 0 || this.optionGroups.length === 0) return;

      this.selected = this.optionGroups.map((group) => {
        const activeButton = group.querySelector('.variant-option.is-active');
        return activeButton ? activeButton.dataset.value : null;
      });

      this.optionGroups.forEach((group) => {
        const buttons = Array.from(group.querySelectorAll('.variant-option'));
        buttons.forEach((button) => {
          button.addEventListener('click', () => this.selectOption(button, group));
        });
        group.addEventListener('keydown', (event) => this.handleGroupKeydown(event, group, buttons));
      });
    }

    handleGroupKeydown(event, group, buttons) {
      const forward = event.key === 'ArrowRight' || event.key === 'ArrowDown';
      const backward = event.key === 'ArrowLeft' || event.key === 'ArrowUp';
      if (!forward && !backward) return;

      event.preventDefault();
      const currentIndex = buttons.findIndex((button) => button.classList.contains('is-active'));
      const delta = forward ? 1 : -1;
      const nextIndex = (currentIndex + delta + buttons.length) % buttons.length;
      const nextButton = buttons[nextIndex];

      nextButton.focus();
      this.selectOption(nextButton, group);
    }

    selectOption(button, group) {
      const index = parseInt(button.dataset.optionIndex, 10);
      this.selected[index] = button.dataset.value;

      group.querySelectorAll('.variant-option').forEach((sibling) => {
        sibling.classList.remove('is-active');
        sibling.setAttribute('aria-checked', 'false');
        sibling.setAttribute('tabindex', '-1');
      });
      button.classList.add('is-active');
      button.setAttribute('aria-checked', 'true');
      button.setAttribute('tabindex', '0');

      const key = this.selected.join('|||');
      const match = this.variantListItems.find((item) => item.dataset.variantOptions === key);
      if (!match) return;

      const available = match.dataset.variantAvailable === 'true';
      const price = match.dataset.variantPrice;
      const image = match.dataset.variantImage || null;

      if (this.priceEl) this.priceEl.textContent = price;
      if (this.variantIdInput) this.variantIdInput.value = match.dataset.variantId;
      if (this.atcButton) {
        this.atcButton.disabled = !available;
        this.atcButton.textContent = available
          ? this.atcButton.dataset.labelAvailable
          : this.atcButton.dataset.labelUnavailable;
      }
      if (this.stockEl) {
        this.stockEl.toggleAttribute('data-out-of-stock', !available);
      }

      document.dispatchEvent(
        new CustomEvent('product:variant-change', {
          bubbles: true,
          detail: { id: match.dataset.variantId, price, available, image },
        })
      );
    }
  }

  customElements.define('product-form', ProductForm);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-sticky-cta"] && !Shopify.designMode) return;
  try {
    class ProductStickyCta extends HTMLElement {
    connectedCallback() {
      this.priceEl = this.querySelector('[data-sticky-price]');
      this.variantIdInput = this.querySelector('[data-sticky-variant-id]');
      this.atcButton = this.querySelector('[data-sticky-atc]');

      const buyboxWrap = document.querySelector('.product-buybox-wrap');
      if (buyboxWrap && 'IntersectionObserver' in window) {
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              this.classList.toggle('is-visible', !entry.isIntersecting);
            });
          },
          { threshold: 0 }
        );
        observer.observe(buyboxWrap);
      }

      document.addEventListener('product:variant-change', (event) => {
        const detail = event.detail;
        if (!detail) return;
        if (this.priceEl) this.priceEl.textContent = detail.price;
        if (this.variantIdInput) this.variantIdInput.value = detail.id;
        if (this.atcButton) {
          this.atcButton.disabled = !detail.available;
          this.atcButton.textContent = detail.available
            ? this.atcButton.dataset.labelAvailable
            : this.atcButton.dataset.labelUnavailable;
        }
      });
    }
  }

  customElements.define('product-sticky-cta', ProductStickyCta);
  } catch(e) { console.error(e); }
})();

})();
